<template>
  <div class="personnelAnalysis">
    <HearderTitle name="人员分析" />
    <div class="main">
      <div class="statistical-analysis-con">
        <h2 class="charh2">年龄分布</h2>
        <div class="charcon">
          <highcharts style="width: 95%; height: 350px" :options="chartOptions1" :callback="Callback"></highcharts>
        </div>
        <div class="box" v-show="show_age">
          <div class="showData">
            <span v-for="(item, index) in showData" :key="index">{{ item }}</span>
          </div>
        </div>
      </div>
      <div class="statistical-analysis-con">
        <h2 class="charh2">性别分布</h2>
        <div class="charcon">
          <highcharts style="width: 95%; height: 350px" :options="chartOptions2" :callback="Callback"></highcharts>
        </div>
        <div class="box" v-show="show_sex">
          <div class="showData">
            <span v-for="(item, index) in showData" :key="index">{{ item }}</span>
          </div>
        </div>
      </div>
      <div class="statistical-analysis-con">
        <h2 class="charh2">司龄分布</h2>
        <div class="charcon">
          <highcharts style="width: 95%; height: 350px" :options="chartOptions3" :callback="Callback"></highcharts>
        </div>
        <div class="box" v-show="show_siLing">
          <div class="showData">
            <span v-for="(item, index) in showData" :key="index">{{ item }}</span>
          </div>
        </div>
      </div>
      <div class="statistical-analysis-con">
        <h2 class="charh2">生日分布</h2>
        <div class="charcon">
          <highcharts style="width: 95%; height: 350px" :options="chartOptions4" :callback="Callback"></highcharts>
        </div>
        <div class="box" v-show="show_birthday">
          <div class="showData">
            <span v-for="(item, index) in showData" :key="index">{{ item }}</span>
          </div>
        </div>
      </div>
      <div class="statistical-analysis-con">
        <h2 class="charh2">户籍分别</h2>
        <div class="charcon">
          <highcharts style="width: 95%; height: 350px" :options="chartOptions5" :callback="Callback"></highcharts>
        </div>
        <div class="box" v-show="show_province">
          <div class="showData">
            <span v-for="(item, index) in showData" :key="index">{{ item }}</span>
          </div>
        </div>
      </div>
      <div class="statistical-analysis-con">
        <h2 class="charh2">学历分布</h2>
        <div class="charcon">
          <highcharts style="width: 95%; height: 350px" :options="chartOptions6" :callback="Callback"></highcharts>
        </div>
        <div class="box" v-show="show_edu">
          <div class="showData">
            <span v-for="(item, index) in showData" :key="index">{{ item }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import HearderTitle from '@/components/HearderTitle'
  import { personnelAnalysis, getPersonnelList } from '@/api/personnelList'
  import { Chart } from 'highcharts-vue'
  export default {
    name: 'personnelAnalysis',
    data() {
      let _this = this
      return {
        show_age: false,
        show_sex: false,
        show_siLing: false,
        show_birthday: false,
        show_province: false,
        show_edu: false,
        age_status: '',
        sex_status: '',
        siLing_status: '',
        birthday_status: '',
        province_status: '',
        edu_status: '',
        personnelList: [],
        info: [],
        showData: [],
        chartOptions1: {
          chart: {
            spacing: [40, 0, 40, 0],
          },
          title: {
            floating: true,
            text: '年龄分布',
          },

          tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                enabled: true,
                format: '<b>{point.name}</b>: {point.percentage:.1f} %',
              },
            },
          },
          series: [
            {
              type: 'pie',
              innerSize: '80%',
              name: '年龄占比',
              data: {},
              events: {
                click: function (e) {
                  if (_this.age_status === e.point.options.name) {
                    _this.show_age = !_this.show_age
                  } else {
                    _this.show_age = true
                  }
                  _this.age_status = e.point.options.name
                  _this.filterData('age', e.point.options.name)
                  _this.show_sex = false
                  _this.show_siLing = false
                  _this.show_birthday = false
                  _this.show_province = false
                  _this.show_edu = false
                },
              },
            },
          ],
          credits: {
            enabled: false,
          },
        },
        Callback: (c) => {
          // 图表初始化完毕后的会掉函数
          // 环形图圆心
          var centerY = c.series[0].center[1],
            titleHeight = parseInt(c.title.styles.fontSize)
          // 动态设置标题位置
          c.setTitle({
            y: centerY + titleHeight / 2,
          })
        },
        chartOptions2: {
          chart: {
            spacing: [40, 0, 40, 0],
          },
          title: {
            floating: true,
            text: '性别分布',
          },
          tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                enabled: true,
                format: '<b>{point.name}</b>: {point.percentage:.1f} %',
              },
            },
          },
          series: [
            {
              type: 'pie',
              innerSize: '80%',
              name: '性别占比',
              data: {},
              events: {
                click: function (e) {
                  if (_this.sex_status === e.point.options.name) {
                    _this.show_sex = !_this.show_sex
                  } else {
                    _this.show_sex = true
                  }
                  _this.sex_status = e.point.options.name
                  _this.filterData('sex', e.point.options.name)
                  _this.show_siLing = false
                  _this.show_birthday = false
                  _this.show_province = false
                  _this.show_edu = false
                  _this.show_age = false
                },
              },
            },
          ],
          credits: {
            enabled: false,
          },
        },
        chartOptions3: {
          chart: {
            spacing: [40, 0, 40, 0],
          },

          title: {
            floating: true,

            text: '司龄分布',
          },

          tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
          },

          plotOptions: {
            pie: {
              allowPointSelect: true,

              cursor: 'pointer',

              dataLabels: {
                enabled: true,

                format: '<b>{point.name}</b>: {point.percentage:.1f} %',
              },
            },
          },

          series: [
            {
              type: 'pie',

              innerSize: '80%',

              name: '司龄占比',

              data: {},
              events: {
                click: function (e) {
                  if (_this.siLing_status === e.point.options.name) {
                    _this.show_siLing = !_this.show_siLing
                  } else {
                    _this.show_siLing = true
                  }
                  _this.siLing_status = e.point.options.name
                  _this.filterData('siLing', e.point.options.name)
                  _this.show_age = false
                  _this.show_sex = false
                  _this.show_birthday = false
                  _this.show_province = false
                  _this.show_edu = false
                },
              },
            },
          ],

          credits: {
            enabled: false,
          },
        },
        chartOptions4: {
          chart: {
            spacing: [40, 0, 40, 0],
          },
          title: {
            floating: true,
            text: '生日分布',
          },
          tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
          },

          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                enabled: true,
                format: '<b>{point.name}</b>: {point.percentage:.1f} %',
              },
            },
          },

          series: [
            {
              type: 'pie',
              innerSize: '80%',
              name: '生日月份占比',
              data: {},
              events: {
                click: function (e) {
                  if (_this.birthday_status === e.point.options.name) {
                    _this.show_birthday = !_this.show_birthday
                  } else {
                    _this.show_birthday = true
                  }
                  _this.birthday_status = e.point.options.name
                  _this.filterData('birthday', e.point.options.name)
                  _this.show_age = false
                  _this.show_sex = false
                  _this.show_siLing = false
                  _this.show_province = false
                  _this.show_edu = false
                },
              },
            },
          ],

          credits: {
            enabled: false,
          },
        },
        chartOptions5: {
          chart: {
            spacing: [40, 0, 40, 0],
          },

          title: {
            floating: true,

            text: '户籍分布',
          },

          tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
          },

          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                enabled: true,
                format: '<b>{point.name}</b>: {point.percentage:.1f} %',
              },
            },
          },

          series: [
            {
              type: 'pie',

              innerSize: '80%',

              name: '户籍占比',

              data: {},
              events: {
                click: function (e) {
                  if (_this.province_status === e.point.options.name) {
                    _this.show_province = !_this.show_province
                  } else {
                    _this.show_province = true
                  }
                  _this.province_status = e.point.options.name
                  _this.filterData('province', e.point.options.name)
                  _this.show_age = false
                  _this.show_sex = false
                  _this.show_siLing = false
                  _this.show_birthday = false
                  _this.show_edu = false
                },
              },
            },
          ],

          credits: {
            enabled: false,
          },
        },
        chartOptions6: {
          chart: {
            spacing: [40, 0, 40, 0],
          },

          title: {
            floating: true,

            text: '学历分布',
          },

          tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
          },

          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                enabled: true,
                format: '<b>{point.name}</b>: {point.percentage:.1f} %',
              },
            },
          },

          series: [
            {
              type: 'pie',

              innerSize: '80%',

              name: '学历占比',

              data: {},
              events: {
                click: function (e) {
                  if (_this.edu_status === e.point.options.name) {
                    _this.show_edu = !_this.show_edu
                  } else {
                    _this.show_edu = true
                  }
                  _this.edu_status = e.point.options.name
                  _this.filterData('edu', e.point.options.name)
                  _this.show_age = false
                  _this.show_sex = false
                  _this.show_siLing = false
                  _this.show_birthday = false
                  _this.show_province = false
                },
              },
            },
          ],

          credits: {
            enabled: false,
          },
        },
      }
    },
    created() {
      this.getPersonnelAnalysis()
    },
    mounted() {
      this.getPersonnelList()
    },
    methods: {
      async getPersonnelAnalysis() {
        let res = await personnelAnalysis()
        this.chartOptions1.series[0].data = res.data.agegv
        this.chartOptions2.series[0].data = res.data.sexgv
        this.chartOptions3.series[0].data = res.data.wkgv
        this.chartOptions4.series[0].data = res.data.srgv
        this.chartOptions5.series[0].data = res.data.hjgv
        this.chartOptions6.series[0].data = res.data.edugv
        this.info = res.data.info
      },
      async getPersonnelList() {
        let { plist } = await getPersonnelList()
        this.personnelList = plist
      },
      filterData(type, condition) {
        switch (type) {
          case 'age':
            this.showData = []
            this.personnelList.forEach((v) => {
              if (condition == '10-19岁') {
                if (v.age >= 10 && v.age <= 19) {
                  this.showData.push(v.pername)
                }
              } else if (condition == '20-29岁') {
                if (v.age >= 20 && v.age <= 29) {
                  this.showData.push(v.pername)
                }
              } else if (condition == '30-39岁') {
                if (v.age >= 30 && v.age <= 39) {
                  this.showData.push(v.pername)
                }
              } else if (condition == '40-49岁') {
                if (v.age >= 40 && v.age <= 49) {
                  this.showData.push(v.pername)
                }
              } else if (condition == '50-59岁') {
                if (v.age >= 50 && v.age <= 59) {
                  this.showData.push(v.pername)
                } else {
                  this.showData.push(v.pername)
                }
              }
            })
            break
          case 'sex':
            this.showData = []
            this.personnelList.forEach((v) => {
              if (condition == '男' && v.sex == '男') {
                this.showData.push(v.pername)
              } else if (condition == '女' && v.sex == '女') {
                this.showData.push(v.pername)
              }
            })

            break
          case 'siLing':
            this.showData = []
            this.personnelList.forEach((v) => {
              if (v.siLing < 0.5 && condition == '小于半年') {
                this.showData.push(v.pername)
              } else if (v.siLing >= 0.5 && v.siLing < 1 && condition == '半年到一年') {
                this.showData.push(v.pername)
              } else if (v.siLing >= 1 && v.siLing < 2 && condition == '1年到2年') {
                this.showData.push(v.pername)
              } else if (v.siLing >= 2 && v.siLing < 3 && condition == '2年到3年') {
                this.showData.push(v.pername)
              } else if (v.siLing >= 3 && v.siLing < 5 && condition == '3年到5年') {
                this.showData.push(v.pername)
              } else if (v.siLing > 5 && condition == '5年以上') {
                this.showData.push(v.pername)
              }
            })
            break
          case 'birthday':
            this.showData = []
            this.personnelList.forEach((v) => {
              let birthday = parseInt(v['birthday'].substr(5, 2)) + '月'
              if (birthday == condition) {
                this.showData.push(v.pername)
              }
            })
            break
          case 'province':
            this.showData = []
            this.personnelList.forEach((v) => {
              if (v.province == condition) {
                this.showData.push(v.pername)
              }
            })
            break
          case 'edu':
            this.showData = []
            this.personnelList.forEach((v) => {
              if (v.edu == condition) {
                this.showData.push(v.pername)
              }
            })
            break
          default:
            break
        }
      },
    },

    components: { HearderTitle, highcharts: Chart },
  }
</script>

<style lang="less" scoped>
  .personnelAnalysis {
    .main {
      width: 100%;
      padding-top: 28px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }
    .statistical-analysis-con {
      .box {
        position: absolute;
        position: absolute;
        width: 92px;
        padding-right: 1px;
        border: 1px dashed #7bb7eb;
        border-radius: 8px;
        right: 4%;
        top: 7.6%;
        z-index: 999;
        padding-top: 10px;
        background-color: #fff;
        box-shadow: 0px 0px 4px 0px rgba(80, 80, 80, 0.3);
        .showData {
          height: 316px;
          overflow-y: auto;
          overflow-x: initial;
          font-size: 14px;

          span {
            width: 100%;
            height: 34px;
            align-items: center;
            display: flex;
            justify-content: center;
          }

          &::-webkit-scrollbar {
            width: 6px;
          }
          &::-webkit-scrollbar-thumb {
            background-color: transparent;
          }
          &:hover {
            &::-webkit-scrollbar {
              width: 6px;
            }
            &::-webkit-scrollbar-thumb {
              background-color: #f2f2f2;
            }
          }
        }
      }

      position: relative;
      display: inline-block;
      box-sizing: border-box;
      width: 48.8%;
      height: 392px;
      border: solid 1px #e6e6e6;
      margin-bottom: 15px;
      .charh2 {
        color: #333;
        text-align: center;
        font-size: 14px;
        line-height: 40px;
        height: 40px;
      }
      .charcon {
        width: 95%;
        height: 350px;
      }
    }
  }
</style>
